<template>
<div>
    <v-btn
      flat
      @click="$router.go(-1)">
      <v-icon dark>chevron_left</v-icon>
      Properties      
    </v-btn>
    <v-toolbar flat>
      <v-toolbar-title>{{currentProperty}} Inventory</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <v-btn @click="AddRecord" slot="activator" color="primary" dark class="mb-2">Add Inventory Item</v-btn>
        <span>Add a New Expense</span>
      </v-tooltip>
    </v-toolbar>
    <v-data-table flat :headers="headers" :items="recordList" :search="search" class="elevation-1" hide-actions>
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.data().type }}</td>
        <td class="text-xs-left">{{ props.item.data().mfg }}</td>
        <td class="text-xs-left">{{ props.item.data().description }}</td>
        <td class="text-xs-left">{{ props.item.data().location }}</td>
        <td class="justify-center layout px-0">
          <v-tooltip bottom>
            <v-icon @click="View(props.item)" slot="activator" small class="mt-3 mr-2">
              edit
            </v-icon>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-icon @click="ConfirmDelete(props.item)" slot="activator" small class="mt-3 mr-2">
              delete
            </v-icon>
            <span>Delete</span>
          </v-tooltip>
        </td>
      </template>
      <template v-slot:no-data>
        NO INVENTORY FOUND
      </template>
      <v-alert v-slot:no-results :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-form ref="form">
      <v-card>
        <v-card-title>
          <span class="headline">Inventory</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6 d-flex>
                <v-select
                  ref="type"
                  :items="inventoryTypes"
                  v-model="modalRecord.type"
                  required
                  :rules="[() => !!modalRecord.type || 'This field is required']"
                  box
                  label="Inventory Type"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field ref="mfg" v-model="modalRecord.mfg" maxlength="50" required :rules="[() => !!modalRecord.mfg || 'This field is required']" label="Mfg or Size" box @focus="$event.target.select()"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field ref="description" v-model="modalRecord.description" maxlength="50" required :rules="[() => !!modalRecord.description || 'This field is required']" label="Description" box @focus="$event.target.select()"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field ref="location" v-model="modalRecord.location" maxlength="50" required :rules="[() => !!modalRecord.location || 'This field is required']" label="Location or Room" box @focus="$event.target.select()"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="CancelSave()">Cancel</v-btn>
          <v-btn color="primary" v-if="this.modalRecord.id === ''" @click="CreateRecord()">Add Item</v-btn>
          <v-btn color="primary" v-if="this.modalRecord.id !== ''" @click="UpdateRecord()">Update Item</v-btn>
        </v-card-actions>
      </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="confirmDelete" persistent max-width="325">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Delete Item?
        </v-card-title>
        <v-card-text>
          <b>Please confirm to delete this item.</b><br/>
          This action cannot undone.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="DeleteRecord">
            DELETE
          </v-btn>
          <v-btn color="primary" @click="confirmDelete=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import db from '../../firebaseInit';

  export default {
    name: 'InventoryList',
    data() {
      return {
        dialog: false,
        confirmDelete: false,
        recordToDelete: "",
        alert: false,
        search: "",
        formHasErrors: false,
        recordList: [
          {
            propertyId: "",
            type: "Furnace Filter",
            mfg: "16x20x1",
            description: "Cheap fiberglass",
            location: "Basement",
            id: ""
          }
        ],
        inventoryTypes: [ { name: "Furnace Filter" } ],
        modalRecord:
        {
          type: "",
          mfg: "",
          description: "",
          location: ""
        },
        headers: [
          { text: 'Type', value: 'type', sortable: false },
          { text: 'Brand', value: 'mfg', sortable: false },
          { text: 'Description', value: 'description', sortable: false },
          { text: 'Location', value: 'location', sortable: false },
          { text: 'Actions', align: 'center', sortable: false  }
        ]      
      }
    },
    methods: {
      GetRecords(){
        db.collection("inventory").where("propertyId", "==", this.propertyId).get().then((querySnapshot) => {
          this.recordList = querySnapshot.docs;  
        });
      },
      GetInventoryTypes() {
        db.collection("inventoryType").get().then((querySnapshot) => {
          //this.inventoryTypes = querySnapshot.docs;  
          for (var i in querySnapshot.docs) {
            const doc = querySnapshot.docs[i];
            this.inventoryTypes.push(doc.data().Name);
          }
        });
      },
      View(item) {
        this.$refs.form.reset();
        this.dialog=true;
        this.$nextTick(() => {
          this.modalRecord = {
            type: item.data().type,
            mfg: item.data().mfg,
            description: item.data().description,
            location: item.data().location,
            id: item.id
          };
          console.log(this.modalRecord);
          //this.$refs.amount.focus();
        });
      },
      AddRecord(){
        this.$refs.form.reset();
        this.dialog=true;
        this.$nextTick(() => {
          this.modalRecord = {
            type: "",
            mfg: "",
            description: "",
            location: "",
            id: ""
          };
          //this.$refs.amount.focus();
        });
      },
      CreateRecord(){
        var that = this; //preserve reference before promise call
        this.formHasErrors = false;

        if (!this.$refs.form.validate()) {
          return;
        }

        // Add a new document with a generated id.
        db.collection("inventory").add({
            propertyId: this.propertyId,
            type: this.modalRecord.type,
            mfg: this.modalRecord.mfg,
            description: this.modalRecord.description,
            location: this.modalRecord.location
        }).then(function(docRef) {
            console.log("Document written with ID: ", docRef.id);
            that.$nextTick(() => {
              that.GetRecords();
            });

            if (!that.formHasErrors)
              that.dialog = false;

        }).catch(function(error) {
            console.error("Error adding document: ", error);
        });
      },
      UpdateRecord(){
        var that = this; //preserve reference before promise call
        this.formHasErrors = false
        if (!this.$refs.form.validate()) {
          return;
        }

        // Add a new document with a generated id.
        db.collection("inventory").doc(this.modalRecord.id).set({
            propertyId: this.propertyId,
            type: this.modalRecord.type,
            mfg: this.modalRecord.mfg,
            description: this.modalRecord.description,
            location: this.modalRecord.location
        }).then(function() {
            console.log("Document updated with ID: ", that.modalRecord.id);
            that.$nextTick(() => {
              that.GetRecords();
            });

            if (!that.formHasErrors)
              that.dialog = false;
        }).catch(function(error) {
            console.error("Error updating document: ", error);
        });
      },
      CancelSave(){
        this.dialog = false;
        this.formHasErrors = false;
      },
      ConfirmDelete(item){
        this.recordToDelete = item.id;
        this.confirmDelete=true;
      },
      DeleteRecord(){
        var that = this; //preserve reference before promise call
        var id = this.recordToDelete;
        console.log("delete - " + id);
        db.collection("inventory").doc(id).delete().then(function() {
          console.log("Document " + id + " successfully deleted!");

          that.$nextTick(() => {
            that.GetRecords();
          });

          that.confirmDelete = false;
        }).catch(function(error) {
          console.error("Error removing document: ", error);
        });
      },
    },
    computed: {
      propertyId(){
        return this.$route.params.id;
      },
      currentProperty(){
        return this.$store.state.currentProperty;
      },
      form () {
        return {
          type: this.modalRecord.type,
          mfg: this.modalRecord.mfg,
          description: this.modalRecord.description,
          location: this.modalRecord.location
        }
      }
    },
    created: function() {
      this.recordList = [];
      this.inventoryTypes = [];
      this.GetRecords();
      this.GetInventoryTypes();
    }
  }
</script>

<style scoped>
</style>